// Action Creators
// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
import { PlanLinkTelemetryComponentName } from "@ms/planner-models/lib/local/constants/PlanLinkConstants";
/** Opens the "connect to an existing plan" dialog when the feature is enabled for a Unified source plan. */ export const openLinkToExistingPlanModal = (isLinkToExistingPlanEnabled, sourceTaskId, sourcePlan, modalActionCreator, telemetryEntryPoint, engagementLogger, onDismiss)=>{
    if (!isLinkToExistingPlanEnabled || sourcePlan?.getPlanType() !== PlanType.Unified) {
        return;
    }
    const modalData = {
        modalType: ModalType.LinkToExistingPlan,
        sourceTaskId,
        telemetryEntryPoint,
        onDismiss
    };
    engagementLogger.logEngagement(PlanLinkTelemetryComponentName, EngagementTelemetryConstants.PLinkEntryPointClicked, {
        operation: "connect-existing",
        entryPoint: telemetryEntryPoint
    });
    modalActionCreator.openModal(modalData);
};
